import React from "react";
import { useSelector } from "react-redux";

/**
 * Full-screen loading overlay driven by `app.showLoading`
 * (mirrors the RN `Loading` component).
 */
const GlobalLoading: React.FC = () => {
  const showLoading = useSelector((state: any) => state.app.showLoading);
  if (!showLoading) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/30">
      <div className="h-10 w-10 animate-spin rounded-full border-4 border-[#ffa217] border-t-transparent" />
    </div>
  );
};

export default GlobalLoading;